import React from 'react';
import { shape, string } from 'prop-types';
import Tooltip from 'components/Map/MapComponents/Tooltip';
import TooltipItem from 'components/Map/MapComponents/TooltipItem';
import SegmentIcon from 'icons/segment-small.inline.svg';

import styles from './ExistingSegmentTooltip.scss';

// @TODO use new components: WithTrend, SpeedDisplay, TimeDisplay, SegmentNameDisplay
export default function ExistingSegmentTooltip({ name }) {
  return (
    <Tooltip sticky offset={[5, -10]} className={styles.main}>
      <TooltipItem label="segment">
        <div className={styles.segment}>
          <SegmentIcon className={styles.segmentIcon} />
          <div className={styles.segmentName}>
            <div className={styles.segmentNameFrom}>
              {name.from}
            </div>
            <div>
              {name.to}
            </div>
          </div>
        </div>
      </TooltipItem>
    </Tooltip>
  );
}

ExistingSegmentTooltip.propTypes = {
  name: shape({ to: string.isRequired, from: string.isRequired }).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/CreateSegment/ExistingSegmentTooltip/index.js